import { render, staticRenderFns } from "./distribuidor_detalhe.vue?vue&type=template&id=cf16f4ca&scoped=true"
import script from "./distribuidor_detalhe.vue?vue&type=script&lang=js"
export * from "./distribuidor_detalhe.vue?vue&type=script&lang=js"
import style0 from "./distribuidor_detalhe.vue?vue&type=style&index=0&id=cf16f4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf16f4ca",
  null
  
)

export default component.exports